import { supabase } from './auth';
import { RecoveryMetrics, SleepMetrics } from '../types';

export interface WearableDayMetrics {
  sleep: SleepMetrics;
  recovery: RecoveryMetrics;
}

/**
 * Latest Apple Health day within the last 2 days (older data shouldn't
 * drive today's recommendation).
 */
export const fetchAppleHealthDay = async (): Promise<WearableDayMetrics | null> => {
  const since = new Date(Date.now() - 2 * 86400000).toISOString().split('T')[0];
  const { data, error } = await supabase
    .from('wearable_days')
    .select('*')
    .eq('source', 'apple-health')
    .gte('day', since)
    .order('day', { ascending: false })
    .limit(1);

  if (error) throw error;
  const day = data?.[0];
  if (!day) return null;

  const timestamp = `${day.day}T08:00:00`;
  return {
    sleep: {
      duration: day.sleep_seconds ?? 0,
      quality: day.sleep_quality ?? 0,
      readiness: 0, // no vendor readiness score; engines use the composite
      timestamp,
    },
    recovery: {
      // Note: Apple Health HRV is SDNN; Oura/Garmin report rmssd. Close
      // enough for trend-based coaching; the coach speaks in ranges.
      hrv: Number(day.hrv_ms ?? 0),
      restingHeartRate: Number(day.resting_hr_bpm ?? 0),
      bodyTemperature: 0,
      timestamp,
    },
  };
};
